import LevelService from '@/taskflex/levels/services/LevelService';
import { SET_LEVELS, SET_IS_LOADING } from '@/taskflex/levels/store/_types';

export default {
    loadLevels({ commit }) {
        return new Promise((resolve, reject) => {
            commit(SET_IS_LOADING, true);

            const options = {
                sort: [
                    {
                        key: 'order',
                        direction: 'asc',
                    },
                ],

                filter_groups: [
                    {
                        filters: [
                            {
                                key: 'enabled',
                                operator: 'eq',
                                value: 1,
                            },
                        ],
                    },
                ],
            };

            LevelService.findAll(options, ({ data }) => {
                commit(SET_LEVELS, data.rows);
                commit(SET_IS_LOADING, false);

                resolve(data);
            }, (response) => {
                reject(response);
            });
        });
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/levels/store/_actions.js